import { render, staticRenderFns } from "./miniStatsDashboard.vue?vue&type=template&id=3062ea23&scoped=true"
import script from "./miniStatsDashboard.vue?vue&type=script&lang=js"
export * from "./miniStatsDashboard.vue?vue&type=script&lang=js"
import style0 from "./miniStatsDashboard.vue?vue&type=style&index=0&id=3062ea23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062ea23",
  null
  
)

export default component.exports